import React, { useContext, useEffect, useState } from 'react';
import { Grid, MenuItem, Paper, Select } from '@material-ui/core';

import { UserContext } from 'contexts/UserContext';
import { FBMAccountPicker } from 'shared';

import { ViewDailySkuPack } from './reports/viewDailySkuPack';
import { ViewExternalSkuUsage } from './reports/viewExternalSkuUsage';
import { ViewOnTimeDelivery } from './reports/viewOnTimeDelivery';
import { ViewOrderPackagingData } from './reports/viewOrderPackagingData';
import { ViewPackagingInventory } from './reports/viewPackagingInventory';
import { ViewReceivingDiscrepancy } from './reports/viewReceivingDiscrepancy';

function FBMViewReports() {
    const { fbmAccount } = useContext(UserContext);

    const reportList = [
        {
            id: 'receiving-discrepancy',
            displayName: 'Receiving Discrepancy',
        },
        {
            id: 'packaging-inventory',
            displayName: 'Packaging Inventory',
        },
        {
            id: 'on-time-delivery',
            displayName: 'On Time Delivery',
        },
        {
            id: 'external-sku-usage',
            displayName: 'External Sku Usage',
        },
        {
            id: 'daily-sku-pack',
            displayName: 'Daily Sku Pack',
        },
        {
            id: 'order-packaging-data',
            displayName: 'Order Packaging Data',
        },
    ];

    const [currentReport, setCurrentReport] = useState(reportList[0].id);

    const handleSelectReportChange = (event) => {
        setCurrentReport(event.target.value);
    };

    const renderSelectedReport = () => {
        switch (currentReport) {
            case 'receiving-discrepancy':
                return <ViewReceivingDiscrepancy />;
            case 'packaging-inventory':
                return <ViewPackagingInventory />;
            case 'on-time-delivery':
                return <ViewOnTimeDelivery />;
            case 'external-sku-usage':
                return <ViewExternalSkuUsage />;
            case 'daily-sku-pack':
                return <ViewDailySkuPack />;
            case 'order-packaging-data':
                return <ViewOrderPackagingData />;
            default:
                return <p>Sorry, this report is not properly configured!</p>;
        }
    };

    return (
        <Paper>
            <FBMAccountPicker fromReportScreen />

            <Grid container>
                <Grid item xs={4}>
                    <span style={{ fontWeight: 'bold', paddingRight: '25px' }}>Report Type:</span>
                    <Select id="frmSelectReport" value={currentReport} onChange={handleSelectReportChange}>
                        {reportList.map((report) => (
                            <MenuItem key={report.id} value={report.id}>
                                {report.displayName}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>

            {renderSelectedReport()}
        </Paper>
    );
}

export { FBMViewReports };
